import { FC, useState } from 'react';
import './SidebarAgentsCategoriesFilter.scss';
import SidebarFilter from '../../../SidebarFilter/SidebarFilter';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { useExample } from '../../../../providers/ExampleProvider';
import { Col, FormGroup, Row } from 'react-bootstrap';
import InputDateRange from '../../../InputDateRange/InputDateRange';
import { useAgentsCategories } from '../../../../providers/Agents/AgentsCategories/AgentsCategoriesProvider';

interface SidebarAgentsCategoriesFilterProps { }

// @ts-ignore
export const defaultValues = {
  name: '',
  startDate: '',
  endDate: '',
} as any;

const SidebarAgentsCategoriesFilter: FC<SidebarAgentsCategoriesFilterProps> = () => {
  const [startDate, setStartDate] = useState<any>(moment(new Date()).format('YYYY-MM-01 HH:mm:ss'));
  const [endDate, setEndDate] = useState<any>(moment(new Date()).format('YYYY-MM-DD HH:mm:ss'));

  const { handleSubmit, register, setValue } = useForm<any>({ defaultValues });

  const { setParams } = useAgentsCategories();

  const onSubmit = async (data: any) => {
    const { page: _page, perPage: _perPage, withPaginate: _withPaginate, ...rest } = data;

    const filter = {
      ...rest,
      startDate: data?.startDate ? moment(data.startDate).format('YYYY-MM-DD') : '',
      endDate: data?.endDate ? moment(data.endDate).format('YYYY-MM-DD') : '',
    };

    setParams((prev: any) => ({
      ...prev,
      filter: { ...(prev?.filter ?? {}), ...filter },
      page: 1,
      perPage: prev?.perPage ?? 10,
      withPaginate: prev?.withPaginate ?? true,
    }));
  }

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div className="SidebarAgentsCategoriesFilter" data-testid="SidebarAgentsCategoriesFilter">
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="name">NOME</label>
              <input
                className="form-control"
                {...register('name')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <InputDateRange
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              setValue={setValue}
              startLabelText={'DATA INICIAL'}
              endLabelText={'DATA FINAL'}
            />
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
}

export default SidebarAgentsCategoriesFilter;
